<!--
 * @Author: wjw this.wujiwen@gmail.com
 * @Date: 2022-10-26 14:23:46
 * @LastEditors: wjw this.wujiwen@gmail.com
 * @LastEditTime: 2023-12-19 10:40:57
 * @FilePath: \unidt\src\view\home\home_acc.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="home-acc">
    <div class="title">让世界更智慧</div>
    <!-- <div class="small-title"></div> -->
    <div class="content">
      立足于算法自主创新与认知智能技术前沿，赋能企业智能化转型。
    </div>
    <img
      :src="footer"
      alt="人工智能大会"
      class="footer"
      v-if="checkSection == 1"
      @click="goPath"
    />
  </div>
</template>
<script>
import footer from "../../../static/img/home/footer.svg";
import Bus from "../../bus";
export default {
  name: "home_acc",
  data() {
    return {
      footer
    };
  },
  props: {
    checkSection: {
      type: Number,
      default: () => 0
    }
  },
  methods: {
    goPath() {
      this.$router.push("/ecologicalWaic");
      Bus.$emit("logo-fixed-flag", false);
    }
  }
};
</script>
<style lang="less" scoped>
.home-acc {
  width: 100%;
  height: 100%;
  background: transparent;
  color: #ffffff;
  overflow: hidden;
  > div {
    width: 76%;
    margin: 0 auto;
  }
  .title {
    margin-top: calc(10% + 96px);
    font-size: 52px;
    text-align: center;
    line-height: 52px;
  }
  .small-title {
    font-size: 36px;
    text-align: center;
    margin-top: 20px;
    line-height: 36px;
  }
  .content {
    font-size: 24px;
    margin-top: 34px;
    color: #ffffff;
    line-height: 44px;
  }
  .footer {
    position: fixed;
    width: 100%;
    bottom: 0px;
    height: 180px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/home/home_acc.vue